import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { SortModule } from "tabulator-tables";
import { Tabulator, FormatModule, DownloadModule, PageModule, ExportModule, RowComponent } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import "tabulator-tables/dist/css/tabulator_bootstrap5.min.css";
import * as XLSX from "xlsx";

interface VendorPayments {
  fiscal_year: number;
  entity_name: string;
  vendor_name: string;
  vendor_beg_name_id: number;
  net_amount: number;
}

type VendorDataProps = {
  data: VendorPayments[];
}

(window as any).XLSX = XLSX;

Tabulator.registerModule([FormatModule, DownloadModule, PageModule, ExportModule, SortModule]);

const EntityVendorHighestPaidTable = forwardRef<InstanceType<typeof Tabulator>, VendorDataProps>(
  ({ data }, ref) => {
    const [isMobile, setIsMobile] = useState(false);
    const tableRef = useRef<HTMLDivElement>(null);
    const tabulatorRef = useRef<InstanceType<typeof Tabulator> | null>(null);

    useImperativeHandle(ref, () => tabulatorRef.current, [tabulatorRef.current]);

    useEffect(() => {
      const mobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
        window.innerWidth < 1025;

      setIsMobile(mobile);

      if (tableRef.current) {
        tableRef.current.innerHTML = "";

        tabulatorRef.current = new Tabulator(tableRef.current, {
          data,
          layout: isMobile ? "fitDataFill" : "fitColumns",
          pagination: "local",
          paginationSize: 10,
          paginationSizeSelector: [10, 25, 50, 100],
          theme: "bootstrap5",
          headerSort: true,
          initialSort: [
            {
              column: "net_amount",
              dir: "desc",
            }
          ],
          rowFormatter: (row: typeof RowComponent) => {
            row.getElement().classList.add("table-striped");
          },
          columns: [
            { 
              titleFormatter: () => {
                const element = document.createElement("span");
                element.innerHTML = "<i class='fas fa-calendar-alt'></i> Year";
                return element;
              }, 
              field: "fiscal_year", 
              titleDownload: "Fiscal Year", 
              headerSort: true 
            },
            { 
              titleFormatter: () => {
                const element = document.createElement("span");
                element.innerHTML = "<i class='fas fa-landmark'></i> Entity";
                return element
              },
              field: "entity_name", 
              titleDownload: "Entity", 
              headerSort: true 
            },
            { 
              titleFormatter: () => {
                const element = document.createElement("span");
                element.innerHTML = "<i class='fas fa-people-carry'></i> Vendor";
                return element;
              },
              field: "vendor_name", 
              titleDownload: "Vendor", 
              headerSort: true, 
            },
            {
              titleFormatter: () => {
                const element = document.createElement("span");
                element.innerHTML = "<i class='fas fa-dollar-sign'></i> Net Amount";
                return element;
              },
              field: "net_amount",
              formatter: "money",
              sorter: "number",
              titleDownload: "Net Amount",
              formatterParams: { decimal: ".", thousand: ",", symbol: "$", precision: 2 },
            },
          ],
        });
      }
    }, [data]);

    return <div ref={tableRef} id="tabulator_table" />;
  }
);

EntityVendorHighestPaidTable.displayName = "EntityVendorHighestPaidTable";

export default EntityVendorHighestPaidTable;